import React from "react";
import { motion } from "framer-motion";
import { Modal } from "react-bootstrap";
import projectsArrays from "../projectsArray";

const ProjectsComp = () => {
  const [modals, setModals] = React.useState(
    projectsArrays.map(() => false)
  );

  const openModal = (index) => {
    setModals((prev) => {
      const next = [...prev];
      next[index] = true;
      return next;
    });
  };

  const closeModal = (index) => {
    setModals((prev) => {
      const next = [...prev];
      next[index] = false;
      return next;
    });
  };

  return (
    <div className="projects-section">
      <motion.h1
        className="projects-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        Projects<span className="projects-dot">.</span>
      </motion.h1>
      <motion.div
        className="projects-grid"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
      >
        {projectsArrays.map((value, index) => (
          <div
            className="project-card"
            key={value.id}
            onClick={() => openModal(index)}
          >
            <img
              src={value.img}
              alt={value.frameworks.split(",")[0]}
              className="project-card-img"
            />
            <div className="project-card-overlay">
              <h3>{value.frameworks.split(",")[0]}</h3>
              <span>View Project</span>
            </div>
          </div>
        ))}
      </motion.div>
      {projectsArrays.map((value, index) => (
        <Modal
          key={value.id}
          show={modals[index]}
          onHide={() => closeModal(index)}
          size="lg"
          centered
          className="project-modal"
        >
          <Modal.Header closeButton className="project-modal-header">
            <Modal.Title />
          </Modal.Header>
          <Modal.Body className="project-modal-body">
            <div className="project-modal-img-wrapper">
              <img
                className="project-modal-img"
                src={value.modalPic}
                alt={value.frameworks.split(",")[0]}
              />
            </div>
            <div className="project-modal-info">
              <div className="project-modal-tags">
                {value.frameworks.split(",").map((fw) => (
                  <span key={fw.trim()} className="project-modal-tag">
                    {fw.trim()}
                  </span>
                ))}
              </div>
              <p className="project-modal-desc">{value.description}</p>
              <a
                href={value.url}
                target="_blank"
                rel="noopener noreferrer"
                className="project-modal-link"
              >
                Visit Site
              </a>
            </div>
          </Modal.Body>
        </Modal>
      ))}
    </div>
  );
};

export default ProjectsComp;
